module.exports = __webpack_public_path__ + "img/image75.b1d6b8eb.png";